import React, { useState, useRef, useEffect } from "react";
import "./Navbar.css";
import { FaUserCircle, FaBars, FaTimes } from "react-icons/fa";
import logo from "../Components/images/MAS Logo Text.png";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
  const [desktopDropdown, setDesktopDropdown] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const desktopRef = useRef(null);
  const mobileRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (desktopRef.current && !desktopRef.current.contains(e.target)) {
        setDesktopDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMobileLink = (path) => {
    setMobileMenu(false);
    setMobileDropdown(false);
    navigate(path);
  };
useEffect(() => {
  if (mobileMenu) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, [mobileMenu]);
  return (
    <div className="mainnavbar">
      <nav className="navbar">
        {/* Logo */}
        <div className="navbar-left">
          <Link to="/home">
            <img src={logo} alt="Logo" className="navbar-logo" />
          </Link>
        </div>
        {/* Desktop Menu */}
        <ul className="navbar-center">
          <li><Link to="/home">Home</Link></li>
          <li className="services" ref={desktopRef}>
            <button
              type="button"
              className="services-btn"
              onClick={(e) => {
                e.stopPropagation();
                setDesktopDropdown(!desktopDropdown);
              }}
            >
              Services ▾
            </button>
            {desktopDropdown && (
              <ul className="dropdown">
                <li><Link to="/Airporttransfers" onClick={() => setDesktopDropdown(false)}>Airport Transfers</Link></li>
                <li><Link to="/chauffer" onClick={() => setDesktopDropdown(false)}>Chauffeur Service</Link></li>
                <li><Link to="/citytocity" onClick={() => setDesktopDropdown(false)}>City to City Transfer</Link></li>
                <li><Link to="/eventtransportation" onClick={() => setDesktopDropdown(false)}>Event Transportation</Link></li>
                <li><Link to="/hirebythehour" onClick={() => setDesktopDropdown(false)}>Hire by the hour</Link></li>
              </ul>
            )}
          </li>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/business">Business</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
        </ul>
        {/* Right Section */}
        <div className="navbar-right">
          <Link to="/loginpage">
            <FaUserCircle className="login-icon" />
          </Link>
          {/* Hamburger (Only Mobile) */}
          <div
            className="hamburger"
            onClick={() => setMobileMenu(!mobileMenu)}
          >
            {mobileMenu ? <FaTimes /> : <FaBars />}
          </div>
        </div>
      </nav>
      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenu ? "active" : ""}`}>
        {/* Top bar: logo + close */}
        <div className="mobile-menu-top">
          <img src={logo} alt="Logo" className="mobile-logo" />
          <div className="mobile-close" onClick={() => setMobileMenu(false)}>
            <FaTimes />
          </div>
        </div>
        {/* Mobile Links */}
        <Link to="/home" onClick={() => setMobileMenu(false)}>Home</Link>
        {/* Mobile Services Dropdown */}
        <div
          className="mobile-services"
          onClick={() => setMobileDropdown(!mobileDropdown)}
        >
          Services ▾
        </div>
        {mobileDropdown && (
          <ul className="mobile-dropdown" ref={mobileRef}>
            <li onClick={() => handleMobileLink("/Airporttransfers")}>Airport Transfers</li>
            <li onClick={() => handleMobileLink("/chauffer")}>Chauffeur Service</li>
            <li onClick={() => handleMobileLink("/citytocity")}>City to City Transfer</li>
            <li onClick={() => handleMobileLink("/eventtransportation")}>Event Transportation</li>
            <li onClick={() => handleMobileLink("/hirebythehour")}>Hire by the Hour</li>
          </ul>
        )}

        <Link to="/about" onClick={() => setMobileMenu(false)}>About Us</Link>
        <Link to="/business" onClick={() => setMobileMenu(false)}>Business</Link>
        <Link to="/contact" onClick={() => setMobileMenu(false)}>Contact Us</Link>
      </div>
    </div>
  );
};

export default Navbar;